import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../../../../../Common/Loaders/Beatloader';
import { getFFSeaExportDirectShipmentList } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaExpAction';
import { convertYYYY_MM_DDtoDD_MMM_YYYYformat } from '../../../../../../../HelperFunctions';
import axios from 'axios';
import { adminMainUrl } from '../../../../../../../Config';
import OverlayLoader from '../../../../../../../Common/Loaders/OverlayLoader';
import Tabbings from '../../../Tabs/Tabbings';


const ListFFSEDirectMBL = ({ accessedModules, accessedPermission, title, ship_status, console_manifest_url, console_master_url, console_house_url, direct_master_url, job_order_url, tab_imp_exp, tab_air_sea }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    //pagination 
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFSeaExportDirectShipmentList(token, user_id, queryParams.get("page") ?? 1));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);

    const {
        loadingFFSeaExpDirectShipmentList,
        FFSeaExpDirectShipmentList,
        FFSeaExpDirectShipmentListError,
        FFSeaExpDirectShipmentListCurrentPage,
        FFSeaExpDirectShipmentListTotalPage,
        FFSeaExpDirectShipmentListTotalData
    } = useSelector(state => state?.FFSeaExpReducer);

    useEffect(() => {
        if (loadingFFSeaExpDirectShipmentList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        console.log("===>", FFSeaExpDirectShipmentList);
    }, [loadingFFSeaExpDirectShipmentList]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);

    const downloadMBL = (id, mbl_number) => {
        if (!id) { toast.error("MBL not found"); return; }
        // console.log("hi hello")
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/sea/export/direct-shipment/mbl/download-mbl?id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `FF_SE_DIRECT_MBL_${mbl_number ? mbl_number : id}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }


    useEffect(() => {
        if (FFSeaExpDirectShipmentList) {
            let arr = [];
            FFSeaExpDirectShipmentList.map((val, index) => {
                let obj = {
                    sno: index + 1,
                    sli_received: val.is_sli_recived,
                    mbl_number: val.mbl_number,
                    job_order_number: val.ff_job_order ? val.ff_job_order.job_order_unique_no : "-",
                    shipper: val.ff_directmbl_shipment_customer ? val.ff_directmbl_shipment_customer.name : "-",

                    shipper_branch: val.ff_directmbl_shipment_customer_branch ? val.ff_directmbl_shipment_customer_branch.branch_name : "-",

                    shipper_bank: val.ff_consolesmbl_shipment_customer_branch_bank ? val.ff_consolesmbl_shipment_customer_branch_bank.entity_name : "-",

                    consignee: val.ff_directmbl_consignee_customer ? val.ff_directmbl_consignee_customer.name : "-",

                    consignee_branch: val.ff_directmbl_consignee_customer_branch ? val.ff_directmbl_consignee_customer_branch.branch_name : "-",


                    notify_address: val.notify_address,
                    notify_email_address: val.notify_email_address,
                    // port_of_loading: val.port_of_loading,
                    // port_of_discharge: val.port_of_discharge,
                    port_of_loading: val.ff_directmbl_loading_port ? val.ff_directmbl_loading_port.name : "",
                    port_of_discharge: val.ff_directmbl_discharge_port ? val.ff_directmbl_discharge_port.name : "",
                    place_of_acceptance: val.place_of_acceptance,
                    place_of_delivery: val.place_of_delivery,
                    place_of_delivery: val.place_of_delivery,
                    vessel_and_voyage_no: val.vessel_and_voyage_no,
                    freight_term: val.freight_term,
                    freight_payable_at: val.freight_payable_at,
                    // airway_bill_date: val.airwaybill_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.airwaybill_date) : "",
                    // clearance_exec_date: val.clearance_Exec_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.clearance_Exec_date) : "",
                    // csr_date: val.CSR_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.CSR_date) : "",
                    // executed_at: val.executed_at ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.executed_at) : "",
                    current_status: val.current_status,
                    action: (
                        <div className="dropdown table-action">
                            <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                                {accessedPermission.includes("ff_se_console_shipment_hbl_edit") && <div className="dropdown-item" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/export/direct/mbl/edit/${btoa(val.id)}`) }} >
                                    <i className="fas fa-edit text-blue-light me-1"></i> Edit
                                </div>}
                                {accessedPermission.includes("ff_se_console_shipment_hbl_download") && <button className="dropdown-item" onClick={() => { downloadMBL(val.id, val.mbl_number) }} disabled={disableDownloadPDF} >
                                    {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download MBL</>}
                                </button>}
                            </div>
                        </div>
                    ),
                };
                arr.push(obj);
            });
            setDataSource(arr);
        }
    }, [FFSeaExpDirectShipmentList]);

    useEffect(() => {
        if (FFSeaExpDirectShipmentListCurrentPage) {
            setCurrentPage(FFSeaExpDirectShipmentListCurrentPage);
        }

        if (FFSeaExpDirectShipmentListTotalPage) {
            setTotalPages(FFSeaExpDirectShipmentListTotalPage)
        }
    }, [
        FFSeaExpDirectShipmentListCurrentPage,
        FFSeaExpDirectShipmentListTotalPage,
        FFSeaExpDirectShipmentListTotalData
    ]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "SLI Received", dataIndex: "sli_received", key: "sli_received" },
        { title: "MBL No.", dataIndex: "mbl_number", key: "mbl_number" },
        { title: "Job Order No.", dataIndex: "job_order_number", key: "job_order_number" },
        { title: "Shipper", dataIndex: "shipper", key: "shipper" },
        { title: "Shipper Branch", dataIndex: "shipper_branch", key: "shipper_branch" },
        // { title: "Shipper Bank", dataIndex: "shipper_bank", key: "shipper_bank" },
        { title: "Consignee", dataIndex: "consignee", key: "consignee" },
        { title: "Consignee Branch", dataIndex: "consignee_branch", key: "consignee_branch" },
        // { title: "Consignee Bank", dataIndex: "consignee_bank", key: "consignee_bank" },
        { title: "Notify Address", dataIndex: "notify_address", key: "notify_address" },
        { title: "Notify Email", dataIndex: "notify_email_address", key: "notify_email_address" },
        { title: "Port of Loding", dataIndex: "port_of_loading", key: "port_of_loading" },
        { title: "Port of Discharge", dataIndex: "port_of_discharge", key: "port_of_discharge" },
        { title: "Place of acceptance", dataIndex: "place_of_acceptance", key: "place_of_acceptance" },
        { title: "Place of delivery", dataIndex: "place_of_delivery", key: "place_of_delivery" },
        { title: "Vessel & Voyage No.", dataIndex: "vessel_and_voyage_no", key: "vessel_and_voyage_no" },
        { title: "Freight term", dataIndex: "freight_term", key: "freight_term" },
        { title: "Freight payable At", dataIndex: "freight_payable_at", key: "freight_payable_at" },
        // { title: "Airway Bill Date", dataIndex: "airway_bill_date", key: "airway_bill_date" },
        // { title: "Clearance Exec Date", dataIndex: "clearance_exec_date", key: "clearance_exec_date" },
        // { title: "CSR Date", dataIndex: "csr_date", key: "csr_date" },
        // { title: "Executed At", dataIndex: "executed_at", key: "executed_at" },
        { title: "Current Status", dataIndex: "current_status", key: "current_status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];




    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    {title} <span className="count-title">{FFSeaExpDirectShipmentListTotalData ? FFSeaExpDirectShipmentListTotalData : "0"}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <Tabbings
                                console_manifest_url={console_manifest_url}
                                console_master_url={console_master_url}
                                console_house_url={console_house_url}
                                direct_master_url={direct_master_url}
                                job_order_url={job_order_url}
                                tab_imp_exp={tab_imp_exp}
                                tab_air_sea={tab_air_sea}
                                accessedPermission={accessedPermission}
                            />
                            <div className="card">
                                <div className="card-header">
                                </div>
                                <div className="card-body">
                                    {/* Contact List */}
                                    <div className="table-responsive custom-table">
                                        <Table className="table datanew dataTable no-footer"
                                            // rowSelection={rowSelection} 
                                            dataSource={dataSource}
                                            columns={columns}
                                            pagination={false} />
                                    </div>

                                    <div className="row align-items-center">
                                        {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                            <ReactPaginate
                                                previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                nextLabel={<img src="/img/left.png" alt="Next" />}
                                                breakLabel="..."
                                                breakClassName="break-me"
                                                pageCount={totalPages}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                forcePage={currentPage - 1}
                                            />
                                        </div> :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }

            {
                disableDownloadPDF && <OverlayLoader />
            }

        </>

    )
}

export default ListFFSEDirectMBL